import { Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';

import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[dfProhibitScientificNotation]'
})
export class ProhibitScientificNotationDirective implements OnInit, OnDestroy {
  constructor(private element: ElementRef, private toastr: ToastrService) {}

  private stream$: Subscription;
  private formValue: any;

  ngOnInit(): void {
    this.formValue = this.element.nativeElement.value;
    this.stream$ = fromEvent(this.element.nativeElement, 'input')
      .pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((value: any) => {
        if ((value.target.value && value.target.value.indexOf('E') !== -1) || value.target.value.indexOf('e') !== -1) {
          this.toastr.error('ç¦æ­¢ä»¥ç§å­¦è®°æ°æ³å½¢å¼è¾å¥');
          this.element.nativeElement.value = this.formValue;
        }
      });
  }
  ngOnDestroy() {
    this.stream$.unsubscribe();
  }
}
